const language = ({ locale }, status) => {
    switch (locale) {
        default:
            return {
                successSentCode: "We've sent an authentication code to %mobileNumber%.",
                errorSentCode: 'Sorry, we were unable to send an authentication code. Please try again.',
                errorVerifyIncorrect: 'The code you entered is either incorrect or has expired. Please try again.',
                error409:
                    "Oops! It looks like you already have an account with us. Please <0>contact us</0> to get access. We can also help if you don't remember signing up previously.",
                error423:
                    'Your account has been locked for security reasons. To remove this lock please <0>contact us</0>.',
                error429: `
                The password you've entered is incorrect. A temporary lock has now been placed on your account.
                You can remove this lock by changing your password. Alternatively, please wait 2
                hours and try again.
            `,
                'error429.cta': 'Reset',
                wrongPassword: `The email or password you've entered is incorrect.`,
                'wrongPassword.cta': 'Forgotten password?',
                passwordAttemptsError:
                    'The password you’ve entered is incorrect. You have {attempts, plural, =1 {# more attempt}other' +
                    '{# more attempts}} before your account is locked temporarily. ' +
                    "'<0>' Need help logging in?'</0>'",

                defaultError: `Oops, something went wrong [${status}]`,
                wrongEmailError: `We couldn't find that email address. Are you sure you've typed it correctly?`,
                'wrongEmailError.cta': 'Sign up',
                accountExistsError: `This email address has already been registered with ClearScore. If you have
            forgotten your password then please reset it using <0>Forgotten password?</0>`,
                finalAttempt:
                    "The email or password you've entered is incorrect. You have 1 more attempt before your account is locked.",
                blockedUserError:
                    'There seems to a problem with your account. Please <0>contact us</0> so we can help.',
                appCodeCopy: 'Please enter the 6-digit code that is generated on the authenticator app to continue.',
            };
    }
};

export default language;
